import { initializeApp } from 'firebase/app';
import { getFirestore} from 'firebase/firestore';
import 'firebase/compat/database'
import 'firebase/compat/firestore'
import 'firebase/auth'

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD43Yqng9pwDZHiJWdptzjh8y3uLU9uulk",
    authDomain: "dev-cloud-plesh.firebaseapp.com",
    projectId: "dev-cloud-plesh",
    storageBucket: "dev-cloud-plesh.firebasestorage.app",
    messagingSenderId: "574969884775",
    appId: "1:574969884775:web:9dcbbca9c6ef52a75fa4c2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);


export {app, db}
